/// zIndex: number
export const zIndex_inkCanvasCompleted = 9;
export const zIndex_inkContainerDiv = 10;
export const zIndex_pdfContainerDiv = 8;
export const zIndex_debugTest = 12;
//# sourceMappingURL=zIndex.js.map